import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API, useAuth } from '../contexts/AuthContext';

const STATUS_LABEL = {
  disconnected: 'Desconectado',
  qrcode: 'Aguardando QR',
  connecting: 'Conectando...',
  connected: 'Conectado',
  banned: 'Banido',
  error: 'Erro',
  desconhecido: 'Desconhecido',
};

const STATUS_COLOR = {
  connected: '#4CB553',
  qrcode: '#fe8d25',
  connecting: '#fe8d25',
  disconnected: '#5E7A82',
  banned: '#b43737',
  error: '#b43737',
  desconhecido: '#5E7A82',
};

function Card({ titulo, valor, icone, cor }) {
  return (
    <div className="col-12 col-sm-6 col-lg-3">
      <div className="card h-100 p-3" style={{ border: '1px solid var(--portal-border)' }}>
        <div className="d-flex align-items-center gap-2 mb-2" style={{ color: cor || 'var(--portal-text)' }}>
          <i className={`bi ${icone}`} style={{ fontSize: '1.3rem' }} />
          <span style={{ fontSize: '0.8rem', color: 'var(--portal-muted)' }}>{titulo}</span>
        </div>
        <div style={{ fontSize: '1.6rem', fontWeight: 700, color: 'var(--portal-text)' }}>{valor}</div>
      </div>
    </div>
  );
}

export default function MartelinhoIndicadores() {
  const { temPermissao } = useAuth();
  const [dados, setDados] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');

  const podeVer = temPermissao('martelinho:visualizar', 'martelinho:gerenciar');

  useEffect(() => {
    if (!podeVer) { setLoading(false); return; }
    axios.get(`${API}/martelinho/indicadores`)
      .then((res) => { setDados(res.data?.data || null); setErro(''); })
      .catch(() => setErro('Não foi possível carregar os indicadores.'))
      .finally(() => setLoading(false));
  }, [podeVer]);

  if (!podeVer) {
    return (
      <div className="container py-4">
        <div className="alert alert-warning">Você não tem permissão para ver os indicadores do Martelinho.</div>
      </div>
    );
  }

  const status = dados?.conexao?.status || 'desconhecido';

  return (
    <div className="container py-4">
      <div className="mb-4">
        <h3 className="mb-1" style={{ color: 'var(--portal-text)' }}>Indicadores do Martelinho</h3>
        <p className="text-muted mb-0" style={{ fontSize: '0.85rem' }}>Visão geral do bot nos últimos 30 dias.</p>
      </div>

      {erro && <div className="alert alert-danger">{erro}</div>}

      {loading ? (
        <div className="text-center py-5"><div className="spinner-border" /></div>
      ) : (
        <div className="row g-3">
          <Card titulo="Usuários autorizados" valor={dados?.total_usuarios ?? '—'} icone="bi-people-fill" cor="#2A8A9C" />
          <Card titulo="Alterações (30 dias)" valor={dados?.acoes_30d ?? '—'} icone="bi-pencil-square" cor="#2A8A9C" />
          <Card titulo="Mensagens enviadas (30 dias)" valor={dados?.mensagens_30d ?? '—'} icone="bi-send-fill" cor="#2A8A9C" />
          <Card
            titulo="Conexão"
            valor={STATUS_LABEL[status] || status}
            icone="bi-whatsapp"
            cor={STATUS_COLOR[status] || '#5E7A82'}
          />
        </div>
      )}
    </div>
  );
}
